<template>
	<div class="head">
		<div class="headText">
			<ul class="picture">
				<img src="../../assets/logo1.png" />
			</ul>
			<ul class="homePage">
				<li><router-link to="/">首页</router-link></li>
				<!--<li><router-link :to="{path:'/courseList',query:{num:111}}">课程</router-link></li>-->
				<li><router-link to="/courseList">课程</router-link></li>
				<li><router-link to="/AboutEnoch">关于以诺</router-link></li>
			</ul>
			<!--<div class="clears"></div>-->
			<div class="login">
				<!-- <p class="customerLink" @click="customerLink">在线咨询</p> -->
				<p class="orderDetails" @click="orderDetails">订单中心</p>
				<p class="lognIn">登录</p>
				<p class="lognOut" ></p>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:"headTop",
		data(){
			return{
				token:localStorage.getItem('token'),
				phone:'',
			}
		},
		methods:{
			orderDetails(){
				if(this.token==null){
					$(".backdrop").css({"display":"block"})
				}else{
					this.$router.push({name:'orderList'})
				}
			},
            customerLink () {
			  let url = 'https://onlinechat.noahgrouptest.com/webchat/jsp/common/visitorEnterq.html?queue=26';
              window.open(url, "_blank");
			},
		},
		created(){
			var that=this
			that.$ajax({
						method:"post",
						url:"/api/UserInfo"
			}).then(function(data){
						that.phone=data.data
						localStorage.setItem("username",data.data.name)
						localStorage.setItem("userphone",data.data.phone)
						localStorage.setItem("realname",data.data.real_name)
						if(that.token==null){
							$(".lognIn").html('登录')
							$(".lognOut").html("")
							$(".lognIn").click(function(){
							$(".backdrop").css({"display":"block"})
							})
						}else if(that.token&&data.data.error){
							$(".lognOut").html("")
							localStorage.clear(that.token)
//							if(data.data.error.code==10003){
//								$(".backdrop").css({"display":"block"})
//							}else{
//								$(".backdrop").css({"display":"none"})
//							}
//							 history.go(0)
						}else{
							$(".lognIn").html(data.data.name)
							$(".lognOut").html("退出")
						}
						$(".lognOut").click(function(){
								localStorage.clear(that.token)
	          					history.go(0)
							})
					})
		},
		mounted(){
			var that=this
    if(window.location.hash=='#/courseList'){
      $(".homePage li a").eq(1).css({"color":"#ffffff","font-weight":"600"})
    }else if(window.location.hash=='#/AboutEnoch'){
      $(".homePage li a").eq(2).css({"color":"#ffffff","font-weight":"600"})
    }

		}
	}
</script>

<style scoped="scoped">
	.head{width:100%;height:70px;background:#08b182;}
	.headText{width:1160px;height:70px;margin:0 auto;}
	.headText ul{float: left;color:#d5ede4;line-height:60px;}
	.headText ul li{float: left;}
	.picture{width:200px;}
	.picture img{margin-top:16px;}
	.homePage{margin-left:200px;position: relative;}
	.homePage li{line-height:70px;text-align: center;font-size: 16px;cursor:pointer;margin-right:60px;}
	.homePage li a{color:#d5ede4;}
	.login{float: right;color:#d5ede4;}
	.login p{float: left;margin-top:30px;font-size: 14px;line-height:14px;cursor:pointer;}
	.orderDetails, .customerLink{margin-right:30px;cursor:pointer;}
	.lognOut{margin-left:10px;border-left:1px solid #fff;padding-left:10px;}
	.activeH{color:#ffffff;}
</style>



// WEBPACK FOOTER //
// headTop.vue?0287fc85